__webpack_require__.p = "https://static.djicdn.com/dji-bbs/v1/_next/";